import React from "react"
import styles from "./loginLoader.module.scss"

export default function LoginLoader(): JSX.Element {
  return (
    <div>
      <h2 className={styles["loading-label"]}>{"Loading..."}</h2>
      <div className={styles["loading-boxes"]}>
        <div className={styles["loading-box"]}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div className={styles["loading-box"]}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div className={styles["loading-box"]}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div className={styles["loading-box"]}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  )
}